import React from "react";
import styles from "./index.module.css";
import Button from "../../atoms/Button";

function Navbar() {
  return (
    <div className={styles.container}>
      <img
        src={"/feemonklogo.png"}
        style={{ width: "7rem" }}
        alt="feemonk_logo"
      />
      <Button
        onPress={() => {
          sessionStorage.setItem(
            "feemonk_data",
            JSON.stringify({ value: "", mob: "" })
          );
          sessionStorage.setItem("ocr_data", JSON.stringify({ id: "" }));
          const rawSource = sessionStorage.getItem("source");
          const source = rawSource ?? "";
          const sourcePaths = {
            "ISBH": "/isb",
            "Professional School of Indian Banking": "/psib",
            "Icon Public School": "/ips",
            "Avinash College of Commerce":'/agi',
            "Datagami Technology Services Private Limited":'/datagami',
          };
          const referrerPath = sourcePaths[source as keyof typeof sourcePaths] ?? "/login";
          const encodedReferrer = encodeURIComponent(
            `${referrerPath}`
          );

          // Construct the final logout URL
          const redirectPath = `/login?referrer=${encodedReferrer}`;

          if(sessionStorage.getItem("templateToken")){
            window.location.href = `/sign-in/${sessionStorage.getItem("templateToken")}`;
          }else if(source){
            window.location.href = redirectPath;
          }else{
            window.location.href = `/login`;
          }
          sessionStorage.clear()
        }}
        text={"Logout"}
      />
    </div>
  );
}

export default Navbar;
